import { setting_obj } from '@/settings/setting';
import { report_api } from '@/api/api/user';
import { isMobile } from './constants';

/**
 * 使用 DOMParser 解码 HTML 实体字符
 * @param {string} encodedString - 包含HTML实体的编码字符串
 * @returns {string} 解码后的原始字符串
 */
export function decodeHTMLEntities(encodedString) {
  // 检查输入是否为字符串类型
  if (typeof encodedString !== 'string') {
    console.warn('decodeHTMLEntities: 输入参数不是字符串类型，将尝试转换为字符串');
    encodedString = String(encodedString);
  }

  // 处理空字符串或无效输入
  if (!encodedString || encodedString.trim() === '') {
    return encodedString;
  }

  try {
    // 创建 DOMParser 实例
    const parser = new DOMParser();
    // 将字符串解析为 HTML 文档
    const doc = parser.parseFromString(encodedString, 'text/html');
    // 获取文档主体的文本内容（自动解码HTML实体）
    return doc.documentElement.textContent;
  } catch (error) {
    console.error('decodeHTMLEntities: 解码过程中发生错误', error);
    // 解码失败时返回原始字符串
    return encodedString;
  }
}

// 时间差计算
/*
 * startDate==>开始时间
 * endDate==>结束时间
 * 事例：diffTime(data.createTime,new Date())
 *
 * */
export function diffTime(startDate, endDate = Date.now()) {
  const diff = endDate - startDate; // .getTime();//时间差的毫秒数
  // 计算出相差天数
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (24 * 3600 * 1000));
  // 计算出小时数
  let returnStr = `刚刚`;
  if (minutes >= 1 && hours < 1) {
    returnStr = `${minutes}分钟前`; // + returnStr;
  }
  if (hours >= 1 && hours < 24) {
    returnStr = `${hours}小时前`; // + returnStr;
  }
  if (days >= 1 && days < 2) {
    returnStr = `昨天`; // + returnStr;
  }
  if (days >= 2) {
    returnStr = new Date(startDate).toLocaleDateString();
  }
  return returnStr;
}
export function diffAbsTime(startDate, endDate = Date.now()) {
  let first_num = '';
  let last_text = '';
  const diff = new Date(endDate).getTime() - new Date(startDate).getTime(); // .getTime();//时间差的毫秒数
  // 计算出相差天数
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (24 * 3600 * 1000));

  // 计算出小时数
  if (hours <= 1) {
    first_num = 1; // + returnStr;
    last_text = '小时';
  }
  if (hours > 1 && hours < 24) {
    first_num = hours;
    last_text = '小时';
  }
  if (hours >= 24) {
    first_num = days;
    last_text = `天`; // + returnStr;
  }

  return { first_num, last_text };
}

/*
 * @Author: your name
 * @Date: 2021-03-19 16:47:50
 * @LastEditTime: 2021-03-19 16:49:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /webUniverse/packages/lanhu-features/src/tools/tools.js
 */
/**
 * 需要转义的字符串
 * @param {string} str
 */
export const replaceStrXSS = (str) => {
  const repObj = {
    // "&":"&amp;",
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#x27;',
    '"': '&quot;',
    '/': '&#x2F;',
  };
  let repBeforeChar = '';
  let repAfterChar = '';
  if (!str || typeof str !== 'string') {
    return str;
  }
  const reg = /[<>"'/]/g;
  // 字符串中包含需要转义的字符
  if (reg.test(str)) {
    for (const k in repObj) {
      if (Object.prototype.hasOwnProperty.call(repObj, k)) {
        repBeforeChar = k;
        repAfterChar = repObj[k];
        const charReg = new RegExp(`${repBeforeChar}`, 'g');
        str = str.replace(charReg, repAfterChar);
      }
    }
  }
  return str;
};
/**
 * 需要反转义的字符串
 * @param {string} str
 */
export const replaceToOriginStr = (str) => {
  const repObj = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&#x27;': "'",
    '&quot;': '"',
    '&#x2F;': '/',
    '&#39;': `'`,
    '&#34;': `"`,
  };
  let repBeforeChar = '';
  let repAfterChar = '';
  if (!str || typeof str !== 'string') {
    return str;
  }
  const reg = /[&<>"'/]/g;
  // 字符串中包含需要转义的字符
  if (reg.test(str)) {
    for (const k in repObj) {
      if (Object.prototype.hasOwnProperty.call(repObj, k)) {
        repBeforeChar = k;
        repAfterChar = repObj[k];
        const charReg = new RegExp(`${repBeforeChar}`, 'g');
        str = str.replace(charReg, repAfterChar);
      }
    }
  }
  return str;
};

export function formatPath(path, prefix) {
  if (!path) return '';
  const pattern = /^https?:\/\//;
  const isFullPath = pattern.test(path);
  return isFullPath ? path : prefix + path;
}

export function urlOperate(url) {
  if (url.indexOf('https://') === 0 || url.indexOf('http://') === 0) {
    return url;
  }
  return setting_obj.website_host + url;
}

export function kFormatter(num) {
  const kNum = Math.sign(num) * (Math.abs(num) / 1000);
  return Math.abs(num) > 999
    ? kNum > 100
      ? `${Math.round(kNum)}k`
      : `${kNum.toFixed(1)}k`
    : Math.sign(num) * Math.abs(num);
}

export function absoluteTime(time) {
  const lastTime = new Date(time).getTime();
  const nowTime = new Date().getTime();
  const result = ((lastTime - nowTime) / (1000 * 60 * 60 * 24)).toFixed(0);
  return result;
}

export function debounce(func, wait, immediate) {
  let timer;

  return function (...args) {
    const context = this;

    if (timer) clearTimeout(timer);
    if (immediate) {
      const callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timer = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
}

export async function upload_img(file) {
  const time_string = `${(Math.random() * 100000).toFixed(0)}_${new Date().getTime()}`;
  const OSS = require('ali-oss');
  const resData = await window.$nuxt.$axios.get('/api/v1/project/documents-tokens');
  let tokensOBJ = {};
  if (resData.data.code === 'OK') {
    tokensOBJ = resData.data.data.Credentials;
  }
  const oss_params = {
    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
    region: 'oss-cn-beijing',
    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    accessKeyId: tokensOBJ.AccessKeyId,
    accessKeySecret: tokensOBJ.AccessKeySecret,
    // 从STS服务获取的安全令牌（SecurityToken）。
    stsToken: tokensOBJ.SecurityToken,
    // 填写Bucket名称。
    bucket: setting_obj.oss_bucket,
    endpoint: setting_obj.imageCdnPath,
    cname: true,
  };
  const oss_client = new OSS(oss_params);
  const result = await oss_client.put(
    `community_audit/${time_string}_${file.name}`,
    file,
    // {headers}
  );
  return result;
}
export function getObjectURL(file) {
  let url = null;
  if (window.createObjectURL !== undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL !== undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL !== undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}
export async function isReport(params) {
  const res = await window.$nuxt.$axios.get(report_api.is_reports, { params });
  const is_report = res?.data?.data?.is_report;
  if (is_report)
    window.$nuxt.$message({
      message: '你已经举报过该作品，信息核实中',
      type: 'success',
    });
  return res?.data?.data?.is_report;
}
export function dfsTransformXssKeys(obj) {
  const stack = [];
  stack.push(obj);
  while (stack.length) {
    const item = stack.pop();
    for (const key in item) {
      if (typeof item[key] === 'object' && item[key] !== null) {
        stack.push(item[key]);
      } else if (typeof item[key] === 'string') {
        item[key] = replaceToOriginStr(item[key]);
      }
    }
  }
}

export function toMasterLogin() {
  location.href = `${setting_obj.router_host}/login?redirect=${location.href}`;
}
export function toTagPage(label) {
  if (!label) return;
  const url = `${window.location.origin}/community/tag/${encodeURIComponent(label)}?cata_name=资源`;
  if (isMobile()) {
    location.href = url;
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
export function isMobileSize() {
  const clientWidth = document.body.clientWidth;
  return clientWidth <= 640;
}

export function isEmailOrIsPhone(value) {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$|^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value); // 邮箱或手机号
}

/**
 * 懒加载
 */
export const lazilyLoadImage = (ref, mount, options = {}) => {
  let observer = null;
  // 懒加载
  if (IntersectionObserver && typeof window !== 'undefined') {
    // 支持监听
    observer = new IntersectionObserver((changes) => {
      changes.forEach((change) => {
        if (change.isIntersecting) {
          // 取消监听
          observer.unobserve(ref);
          // 回调
          mount?.();
        }
      });
    }, options);
    observer.observe(ref);
    return () => {
      observer.disconnect();
    };
  }
  if ('loading' in HTMLImageElement.prototype && ref instanceof HTMLImageElement) {
    // 懒加载
    ref.loading = 'lazy';
  } else {
    // 啥都没有的浏览器......
  }
  mount?.();
  // eslint-disable-next-line
  return () => {};
};

function setClipboard(text) {
  return new Promise((resolve, reject) => {
    // setTimeout 用于兼容 Safari
    setTimeout(() => {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
          console.error(err);
        });
    });
  });
}

export function copyToClipboard(content, useTextArea = false) {
  if (typeof navigator.clipboard?.write === 'function') {
    return setClipboard(content);
  }

  const element = useTextArea ? document.createElement('textarea') : document.createElement('input');
  element.value = content;
  document.body.appendChild(element);
  element.select();
  const success = document.execCommand('copy');
  document.body.removeChild(element);
  return success;
}
